import { render, staticRenderFns } from "./FooterComponentEn.vue?vue&type=template&id=5d3109ed&scoped=true"
import script from "./FooterComponentEn.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEn.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEn.vue?vue&type=style&index=0&id=5d3109ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3109ed",
  null
  
)

export default component.exports